module.exports = __webpack_public_path__ + "img/gartek-portfolio-historic-restoration.8d2bd058.jpeg";